import { createSelector } from 'reselect'
import * as featureFlagSvc from 'services/feature-flag'
import { selectors } from 'services/customer-360'

export const isChangeOwnerEnabled = createSelector(
  [featureFlagSvc.selectors.selectFeatureFlagByName('change_owner'), selectors.lines],
  (changeOwnerFlag, lines) => !!(changeOwnerFlag && lines && lines.length),
)
